export default __webpack_public_path__ + "static/media/a5.2c9a076d.png";